import React from 'react';
import {FormGroup} from "react-bootstrap";
import {MaintenanceAndRepairSubTypes, ServiceFeeTypeLabel} from "../constants/securspace-constants";

interface MaintenanceAndRepairFormGroupProps {
  /** Selected maintenance and repair service fee type (e.g. `MUDFLAP_REPAIR`) */
  value: string;
  onChange: (serviceFeeType: string) => void;
}

const MaintenanceAndRepairFormGroup = (props: MaintenanceAndRepairFormGroupProps) => {
  const {onChange, value} = props;

  const handleOnChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    onChange(e.target.value);
  }

  // Note: a `placeholder` attribute was removed from the <select>; it is not a valid
  // <select> attribute, so browsers ignored it and it never rendered.
  return <FormGroup>
    <label htmlFor={'select-sub-fee-type'}>Maintenance and Repair Type:*</label>
    <select id={'select-sub-fee-type'} className={'form-control'} value={value} onChange={handleOnChange}>
      {
        MaintenanceAndRepairSubTypes.map(maintenanceRepairType => <option value={maintenanceRepairType} key={maintenanceRepairType}>{ServiceFeeTypeLabel[maintenanceRepairType]}</option>)
      }
    </select>
  </FormGroup>
}

export default MaintenanceAndRepairFormGroup;
